module.exports = __webpack_public_path__ + "media/images/illustrations/phone_gps_tracking-dc83e2ff86e496701fe626a8e279491d.svg";